import {
  Stack,
  Avatar,
  Typography,
  Card,
  Box,
  CardActions,
  Button,
  Chip,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useArcAuth } from "@arcauth/react-sdk";
import UserIcon from "../../shared/icon/user-icon";
import { useNavigate } from "react-router-dom";
import AddAddress from "./create";
import RemoveAddress from "./remove";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux/features/rootSlice";
import { getUserInfo } from "../../redux/features/user.slice";

interface loadingSkel {
  loading?: boolean;
}

const MyAddress = (props: loadingSkel) => {
  const { loading = false } = props;
  const [open, setOpen] = useState(false);
  const [removeopen, setRemoveOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<any>({});
  // Pull user/authentication/loading state from ArcAuth context
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, login } = useArcAuth();
  let user = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
  useEffect(() => {
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated, navigate]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(getUserInfo());
  //   }, 500);
  // }, []);

  const OpenDialog = (item: any) => {
    setSelectedAddress({
      id: item?.id,
      name: item?.name,
      street2: item?.street2,
      city: item?.city,
      state: item?.state,
      zip: item?.zip,
      country: item?.country,
      phone: item?.phone,
      email: item?.email,
      addressname: item?.addressname,
      isdefault: item?.isdefault,
      companyname: item?.companyname,
    });
    setOpen(true);
  };

  const OpenEditDialog = (item: any) => {
    setIsEditOpen(true);
    OpenDialog(item ?? "");
  };

  const OpenAddDialog = (item: any) => {
    setIsEditOpen(false);
    OpenDialog(item ?? "");
  };

  const OpenRemoveDialog = (item: any) => {
    setSelectedAddress({
      id: item?.id,
      name: item?.name,
      street2: item?.street2,
      city: item?.city,
      state: item?.state,
      zip: item?.zip,
      country: item?.country,
      phone: item?.phone,
      email: item?.email,
      addressname: item?.addressname,
      isdefault: item?.isdefault,
      companyname: item?.companyname,
    });
    setRemoveOpen(true);
  };

  const clearForm = () => {
    setSelectedAddress({
      id: null,
      name: null,
      street2: "Business",
      city: null,
      state: null,
      zip: null,
      country: null,
      phone: null,
      email: null,
      addressname: null,
      isdefault: false,
      companyname: null,
    });
  };

  const DialogClose = () => {
    setOpen(false);
    setRemoveOpen(false);
    clearForm();
  };
  return (
    <>
      <Stack textAlign={'center'} gap={1} alignItems={"center"}>
        <Typography variant="h1" color="initial" fontSize={{ xs: '1.5  rem', md: '2.5rem' }}>
          My addresses
        </Typography>
        <Typography variant="body2" color="initial">
          Add your address for accurate location-based services
        </Typography>
      </Stack>
      <Stack
        direction={"row"}
        gap={2}
        justifyContent={"center"}
        flexWrap={"wrap"}
        sx={{
          py: 3,
          ".MuiPaper-root ": { display: "flex", flexDirection: "column" },
          ".MuiTypography-root": {
            display: "flex",
            alignItems: "center",
            gap: ".7rem",
          },
          ".MuiCardActions-root": {
            borderTop: "1px solid #eee",
            pb: 0,
            mt: "auto",
          },
        }}
      >
        {loading ? (

          <Skeleton sx={{ background: '#fff' }} variant="rectangular" width={300} height={230} />
        ) : (
          <Card
            elevation={0}
            sx={{ p: 2, width: 300, minWidth: 300, cursor: "pointer" }}
          >
            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              height={"100%"}
              onClick={OpenAddDialog}
              minHeight={170}
            >
              <Avatar
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "#FFD6CC",
                  color: "#EC3548",
                  fontSize: '2.8rem'
                }}
              >
                +
              </Avatar>
              Add new address
            </Stack>
          </Card>
        )}

        {user?.address &&
          user?.address.map((item: any) => (
            <Card key={item.id} elevation={0} sx={{ p: 2, width: 300 }}>

              <Stack direction={"row"} gap={1.2} alignItems={'center'}>
                <Avatar sizes="small" sx={{ svg: { stroke: '#000' }, background: '#e5e5e5', width: 22, height: 22, p: '6px' }}>
                  <UserIcon />
                </Avatar>
                <Typography
                  variant="body1"
                  color="initial"
                  fontWeight={"normal"}
                  sx={{ wordBreak: 'break-word', lineHeight: 1.2 }}
                >
                  {item?.name ?? ""}
                </Typography>
                <Chip
                  sx={{ ml: 'auto' }}
                  label={item?.street2}
                  size="small"
                />
              </Stack>
              <Stack pb={1} mt={2}>
                <Typography variant="body2" color="initial">
                  {item?.addressname ?? ""}
                </Typography>
                <Typography variant="body2" color="initial" sx={{ display: 'flex', gap: 1 }}>
                  <span>{item?.state ?? ""}</span>
                  <span>{item?.city ?? ""}</span>
                  <span>{item?.zip ?? ""}</span>
                </Typography>
                <Typography variant="body2" color="initial">
                  {item?.country ?? ""}
                </Typography>
                <Typography variant="body2" color="initial">
                  {item?.phone ?? ""}
                </Typography>
              </Stack>
              <CardActions sx={{ gap: 3, px: 0 }}>
                <Button
                  onClick={() => OpenEditDialog(item ?? "")}
                  variant="text"
                  size="small"
                  sx={{ ':hover': { background: 'transparent' }, p: 0, minWidth: 0 }}
                >
                  Edit
                </Button>
                <Button
                  variant="text"
                  size="small"
                  sx={{ ':hover': { background: 'transparent' }, p: 0, minWidth: 0 }}
                  onClick={() => OpenRemoveDialog(item ?? "")}
                >
                  Remove
                </Button>
              </CardActions>
            </Card>
          ))}
      </Stack>
      <AddAddress
        open={open}
        onClose={DialogClose}
        address={selectedAddress}
        isEditOpen={isEditOpen}
      />
      <RemoveAddress
        open={removeopen}
        onClose={DialogClose}
        deleteAddress={selectedAddress}
      />
    </>
  );
};

export default MyAddress;
